import React from 'react';
import styled from 'styled-components';
import { CenterRowDiv, Div, H4, RowDiv, Span, theme } from 'styles';
import { Icon } from './Icon';

export function Card({ icon, title, sub, desc, children, $pathFill, ...props }) {
  return (
    <Container {...props}>
      <TitleDiv>
        <RowDiv $gap={4} $alignItems="center">
          <Icon name={icon} $pathFill={$pathFill} />
          <H4 $type="m18">
            {title}
            {sub && (
              <Span $color="supportive" $paddingLeft={12}>
                {sub}
              </Span>
            )}
          </H4>
        </RowDiv>
        {desc && <>{desc}</>}
      </TitleDiv>
      <Div $padding="24px">{children}</Div>
    </Container>
  );
}

const Container = styled(Div)`
  border-radius: 8px;
  box-shadow: ${theme.shadows.box};
`;

const TitleDiv = styled(CenterRowDiv)`
  padding: 0 12px;
  height: 48px;
  justify-content: space-between;
  border-bottom: 1px solid ${theme.colors.gray100};
`;
